import React from "react";
import {
  Row,
  Col,
  Input,
  Button,
  Space,
  message,
  Modal,
  Form,
  Select,
  DatePicker,
  Checkbox,
  Tooltip,
  Image,
  Drawer,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { Link } from "react-router-dom";
import CompanyAutocomplete from "./CompanyAutocomplete";
import ListTable from "./ListTable";
import withRouter from "../withRouter";
import WASLTripStore from "../store/WASLTripStore";
import WASLVehicleStore from "../store/WASLVehicleStore";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
import { decode as base64_decode } from "base-64";
import Cookies from "js-cookie";
const dateTimeFormat = "YYYY-MM-DD HH:mm:ss";

let widthAdderFunc = (arr) => {
  let array = arr;
  array.map((val) => {
    if (val.title?.length > 24) {
      val.width = 250;
    } else if (val.title?.length > 15) {
      val.width = 200;
    } else if (val.title?.length > 12) {
      val.width = 150;
    } else if (val.title?.length > 8) {
      val.width = 125;
    } else {
      val.width = 110;
    }
  });

  return arr;
};

class WASLTrip extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    // this.onDelete = this.onDelete.bind(this);

    this.waslTripStore = new WASLTripStore(this);
    this.waslVehicleStore = new WASLVehicleStore(this);

    this.state = {
      showWASLRegistration: false,
      loading: false,
      pageSize: 50,
      currentPage: 1,
      openConfirm: false,
      confirmLoading: false,
      loadList: 0,
      Company: true,
      Individual: false,
      cname: "",
      identityNo: "",
      crNo: "",
      loadData: 0,
      companyId: "",
      tripNumber: 1,

      UcompanyId: "",
      cid: "",

      modalVisible: false,
      selectedColumns: widthAdderFunc([
        {
          // title: "Account",
          title: context.translate("_FLEET_DASHBORD_NEWPOI_CUSTOMER_"),
          dataIndex: "name",
          key: "name",
          ellipsis: true,
        },
        {
          // title: "Vehicle No",
          title: context.translate("_VEHICLE_NO_"),
          dataIndex: "vehicleNo",
          key: "vehicleNo",
          ellipsis: true,
        },
        {
          // title: "Sequence Number",
          title: context.translate("_SEQUENCE_NUMBER_"),
          dataIndex: "sequenceNumber",
          key: "sequenceNumber",
          ellipsis: true,
        },
        {
          // title: "Primary Driver",
          title: context.translate("_PRIMARY_DRIVER_"),
          dataIndex: "primaryDriver",
          key: "primaryDriver",
          ellipsis: true,
        },
        {
          // title: "Assistant Driver",
          title: context.translate("_ASSISTANT_DRIVER_"),
          dataIndex: "assistantDriver",
          key: "assistantDriver",
          ellipsis: true,
        },
        {
          // title: "Trip Number",
          title: context.translate("_TRIP_NUMBER_"),
          dataIndex: "tripNumber",
          key: "tripNumber",
          ellipsis: true,
        },
        {
          // title: "Distance In Meters",
          title: context.translate("_DISTANCE_IN_METERS_"),
          dataIndex: "distanceInMeters",
          key: "distanceInMeters",
          ellipsis: true,
        },
        {
          // title:"No Of Passengers",
          title: context.translate("_NO_OF_PASSENGERS_"),
          dataIndex: "noOfPassenger",
          key: "noOfPassenger",
          ellipsis: true,
        },
        {
          // title: "Trip Type",
          title: context.translate("_WASL_TRIP_TYPE_"),
          dataIndex: "tripType",
          key: "tripType",
          ellipsis: true,
        },
        {
          // title: "Activity",
          title: context.translate("_ACTIVITY_"),
          dataIndex: "activity",
          key: "activity",
          ellipsis: true,
        },
        {
          // title: "Response",
          title: context.translate("_RESPONSE_"),
          dataIndex: "response",
          key: "response",
          ellipsis: true,
        },
        {
          // title: "Reply",
          title: context.translate("_REPLY_"),
          dataIndex: "reply",
          key: "reply",
          ellipsis: true,
        },
        {
          // title:"Status",
          title: context.translate("_ORDER_STATUS_"),
          dataIndex: "status",
          key: "status",
          ellipsis: true,
        },

        {
          // title:"Action",
          title: context.translate("_ACTION_"),
          dataIndex: "Action",
          // fixed: "right",
          width: "5%",
          ellipsis: true,
          // render: (_, record) => {
          //   return (
          //     <>
          //       <Space>
          //         <SearchOutlined
          //           onClick={async() => {
          //            await this.WASLCompanyStatus(record);
          //            await this.warning();
          //           }}
          //         />

          //         <DeleteConfirm
          //           onConfirm={(e) => {
          //             this.onDelete(record);
          //           }}
          //         >
          //           <Link
          //             onClick={(e) => {
          //               e.preventDefault();
          //             }}
          //           >
          //             <DeleteFilled style={{ color: config.deleteColor }} />
          //           </Link>
          //         </DeleteConfirm>
          //       </Space>
          //     </>
          //   );
          // },
        },
      ]),
    };
    this.formRef = React.createRef();

    this.newColumns = widthAdderFunc([
      ...this.state.selectedColumns,
      {
        // title: "Primary Driver Identity No.",
        title: context.translate("_PRIMARY_DRIVER_IDENTITY_"),
        dataIndex: "primaryDriver",
        key: "primaryDriverNo",
        ellipsis: true,
      },
      {
        // title: "Assistant Driver Identity No.",
        title: context.translate("_ASSISTANT_DRIVER_IDENTITY_"),
        dataIndex: "primaryIdentityNumber",
        key: "primaryIdentityNumber",
        ellipsis: true,
      },
      {
        // title: "Expected Arrival Time",
        title: context.translate("_WASL_TRIP_ARRIVAL_TIME"),
        dataIndex: "arrivalTime",
        key: "arrivalTime",
        ellipsis: true,
      },
      {
        // title: "Expected Departure Time",
        title: context.translate("_WASL_TRIP_DEPARTURE_TIME"),
        dataIndex: "departureTime",
        key: "departureTime",
        ellipsis: true,
      },
      {
        // title: "Departure Station Code",
        title: context.translate("_WASL_TRIP_DEPARTURE_STATION_CODE_"),
        dataIndex: "depStationCode",
        key: "depStationCode",
        ellipsis: true,
      },
      {
        // title: "Arrival Station Code",
        title: context.translate("_WASL_TRIP_ARRIVAL_STATION_CODE_"),
        dataIndex: "arStationCode",
        key: "arStationCode",
        ellipsis: true,
      },
    ]);
  }
  async componentDidMount() {
    await this.setState({ column: this.state.selectedColumns });
    this.setState({ pageSize: 50 });

    const stationData = await this.waslTripStore.getAllStation();
    await this.setState({ stationData: stationData });
  }

  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    this.handleSearch();
  }

  async handleChange(comp) {
    await this.setState({ companyId: comp.value });

    await this.waslVehicleStore.getVehiclesByCompanyId({
      companyId: comp.value,
    });

    await this.waslTripStore.getDriverName({
      companyId: comp.value,
    });

    await this.handleSearch();
    // await this.setState({loadList:1})
  }

  async handleSearch() {
    this.setState({ loading: true });
    await this.waslTripStore.loadData({
      companyId: this.state.companyId,
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      searchField: this.state.searchField,
    });
    await this.setState({ loadList: 0 });
    // this.setState({ loading: false });
  }

  onWASLTripRegistrationFinish = async (value) => {
    const data = {
      ...value,
      userId: 1,

      departureTime: value.departureTime.format("YYYY-MM-DD HH:mm:ss"),
      arrivalTime: value.arrivalTime.format("YYYY-MM-DD HH:mm:ss"),

      companyId: this.state.companyId,
    };

    const response = await this.waslTripStore.registerTrip(data);
    if (response?.success === "S") {
      message.success(response.data.message);
    } else {
      message.error(response.data.message);
    }
    if (response.data.message) {
      this.setState({ showWASLRegistration: false });
      this.formRef.current?.resetFields();
    }
  };

  validateNumber = (value, field) => {
    const value1 = value.replace(/[^0-9+]*/g, "");

    if (value1) {
      this.formRef.current.setFieldsValue({ [field]: value1 });
    } else {
      this.formRef.current.setFieldsValue({ [field]: "" });
    }
  };

  searchFieldsFun = async (e) => {
    const searchFields = e.target.value;
    this.setState({ searchField: searchFields });
    if (searchFields.length > 3 || searchFields.length === 0) {
      await this.waslCompanyStore.loadData({
        offset: (this.state.currentPage - 1) * this.state.pageSize,
        limit: this.state.pageSize,
        searchField: searchFields,
      });
      await this.setState({ loadList: 0 });
    }
  };

  setPrimaryIdentityNumber = async (driverId) => {
    const data = await this.waslTripStore.getDriverInfo(driverId);

    await this.formRef.current.setFieldsValue({
      primaryIdentityNumber: data.licensenumber,
    });
  };

  setAssistantIdentityNumber = async (driverId) => {
    const data = await this.waslTripStore.getDriverInfo(driverId);

    await this.formRef.current.setFieldsValue({
      assistantIdentityNumber: data.licensenumber,
    });
  };

  setVehicleInfo = async (vehicleId) => {
    const data = await this.waslVehicleStore.getVehicleInfo(vehicleId);

    await this.formRef.current.setFieldsValue({ imeiNumber: data.full_imei });
    await this.formRef.current.setFieldsValue({ number: data.vehicleNo });
    await this.formRef.current.setFieldsValue({
      sequenceNumber: data.sequenceNo,
    });
    await this.formRef.current.setFieldsValue({ plateType: data.plateType });
  };

  handleCheckboxChange = async (column) => {
    if (this.state.selectedColumns.some((c) => c.key === column.key)) {
      const filtered = this.state.selectedColumns.filter(
        (c) => c.key !== column.key
      );

      await this.setState({
        selectedColumns: filtered,
      });
      await this.setState({ column: filtered });
      // await  this.updateVisibleColumns();
    } else {
      await this.setState({
        selectedColumns: [...this.state.selectedColumns, column],
        column: [...this.state.selectedColumns, column],
      });
      // await  this.updateVisibleColumns();
    }
  };

  render() {
    return (
      <>
        {/* <div style={{ padding: 0 }}>
          <Row className="headerFixed" style={{ height: "50px" }}>
            <Col span={12}>
              <div className="heading">
                {this.context.translate("_WASL_TRIP_LIST_")}
              </div>
            </Col>
            <Col
              span={12}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Space style={{}}>
                <Link to={"/vehiclelist"}>
                  <Button ghost type="primary">
                    {this.context.translate("_BACK_")}
                  </Button>
                </Link>
                <Button
                  type="primary"
                  onClick={() => this.setState({ showWASLRegistration: true })}
                >
                  + {this.context.translate("_REGISTER_")}
                </Button>

                <Button
                  style={{ backgroundColor: config.activeColor }}
                  disabled={
                    this.waslCompanyStore?.WASLCompanyArray.length > 0
                      ? false
                      : true
                  }
                  onClick={async (val) => {
                    const result = [];
                    await this.columns.map((obj) => result.push(obj.dataIndex));
                    //  console.log(result.toString())
                    var getData = {
                      cid: this.state.cid,
                      UcompanyId: this.state.UcompanyId,
                      colList: result,
                    };
                    await this.waslCompanyStore.exportExcel(getData);
                    await this.setState({ loadList: 1 });
                  }}
                >
                  <i
                    class="bi bi-file-arrow-down"
                    style={{ marginRight: "5px" }}
                  ></i>
                  {this.context.translate("_EXPORT_")}
                </Button>

                <Button onClick={() => this.setState({ modalVisible: true })}>
               
                  {this.context.translate("_COLUMNS_")}
                </Button>
              </Space>
            </Col>
          </Row>
        </div> */}
        <div className="listHeader">
          <Row className="listInputRow">
            <Space>
              <CompanyAutocomplete
                onChange={(value) => {
                  this.handleChange(value);
                }}
                style={{ width: 200 }}
              />
              <Input
                style={{ width: 300 }}
                // placeholder="Plate No,Sequence Number"
                placeholder={this.context.translate("_PLATE_NO_SEQUENCENO_")}
                // onChange={async (e) => {
                //   this.searchFieldsFun(e);
                //   // this.handleSearch();
                // }}
              ></Input>

              {/* <Button type="primary" onClick={() => this.handleSearch()}>
                <SearchOutlined />
              </Button> */}
            </Space>
            <Space
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Link to={"/vehiclelist"}>
                <Button className="addButtonClass">
                  {this.context.translate("_BACK_")}
                </Button>
              </Link>
              <Button
                className="addButtonClass"
                // type="primary"
                onClick={() => this.setState({ showWASLRegistration: true })}
              >
                <Image
                  style={{ marginInlineEnd: "5px", width: 13 }}
                  src={require("../assets/images/NewDesign/plus (Stroke).png")}
                />
                {this.context.translate("_REGISTER_")}
              </Button>

              <Button
                className="downloadExcelButton"
                disabled={
                  this.waslVehicleStore?.WASLVehicleArray?.length > 0
                    ? false
                    : true
                }
                onClick={async () => {
                  const result = [];
                  await this.columns.map((obj) => result.push(obj.dataIndex));
                  var getData = {
                    companyId: this.state.companyId,
                    UcompanyId: JSON.parse(base64_decode(Cookies.get("data")))
                      .UcompanyId,
                    vehicleId: this.state.selectVehicle,
                    sequenceNo: this.state.sequenceNo,
                    colList: result,
                  };
                  await this.waslVehicleStore.exportExcel(getData);
                  await this.setState({ loadList: 1 });
                }}
              >
                <Tooltip title="Download Excel" placement="bottom">
                  <Image
                    style={{
                      height: 18,
                      width: "auto",
                    }}
                    src={downloadIcon}
                  />
                </Tooltip>
              </Button>

              <Button
                className="addButtonClass"
                onClick={() => this.setState({ modalVisible: true })}
              >
                {this.context.translate("_COLUMNS_")}
              </Button>
            </Space>
          </Row>

          <ListTable
            current={this.state.currentPage}
            total={this.waslTripStore?.total}
            columns={this.state.selectedColumns}
            dataSource={this.waslTripStore?.WASLTripArray}
            loading={this.waslTripStore?.loading}
            onChange={this.handleTableChange}
          />

          {/* <Modal
            title={this.context.translate("_WASL_TRIP_REGISTRATION_")}
            // title="WASL Trip Registration"
            destroyOnClose={true}
            open={this.state.showWASLRegistration}
            onCancel={() => this.setState({ showWASLRegistration: false })}
            footer={null}
            width={800}
            style={{
              top: 20,
            }}
            // onOk={}
          > */}
          <Drawer
            className="accountFormDrawer"
            width={716}
            closeIcon={false}
            open={this.state.showWASLRegistration}
            placement={
              this.context.locale.language === "english" ? "right" : "left"
            }
            title={
              <div className="formTitle">
                {this.context.translate("_WASL_TRIP_REGISTRATION_")}
                <p className="formDescription">
                  {this.context.translate("_DRIVER_ADD_DESC_")}
                </p>
              </div>
            }
            footer={false}
            maskClosable={false}
            onOk={() => this.setState({ showWASLRegistration: false })}
            onCancel={() =>
              this.setState({
                showWASLRegistration: false,
              })
            }
          >
            <Form
              ref={this.formRef}
              layout="vertical"
              name="companyFrm"
              onFinish={this.onWASLTripRegistrationFinish}
              // initialValues={{ mapSetting: false, mapSetting2: false }}
              style={{ maxWidth: "100%", padding: 0 }}
              className="formClass"
            >
              <Row className="overflowFormInputs">
                <Col span={12} className="waslFormClass">
                  <Form.Item
                    className="formFieldsStyle"
                    name="companyId"
                    label={
                      <span>
                        {this.context.translate("_ACCOUNT_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_FLEET_DRIVER_DRIVERDETAIL_COMPANY_"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                  >
                    <CompanyAutocomplete
                      onChange={(value) => {
                        this.handleChange(value);
                      }}
                      style={{ width: "100%" }}
                    />
                  </Form.Item>

                  <Form.Item
                    className="formFieldsStyle"
                    name="vehicleId"
                    label={
                      <span>
                        {this.context.translate(
                          "_FLEET_DASHBORD_VEHICLE_HISTORY_VEHICLE_"
                        )}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_FLEET_DASHBORD_VEHICLE_HISTORY_VEHICLE_"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                  >
                    <Select
                      name="vehicleId"
                      onChange={async (e) => await this.setVehicleInfo(e)}
                      fieldNames={{ label: "vehicleNo", value: "vehicleId" }}
                      placeholder={this.context.translate(
                        "_FLEET_DASHBORD_VEHICLE_VIEWICON_TITLE_"
                      )}
                      optionFilterProp="children"
                      options={this.waslVehicleStore?.getVehiclesUsingCompanyId}
                      style={{ width: "100%" }}
                    />
                  </Form.Item>

                  <Form.Item
                    className="formFieldsStyle"
                    name="sequenceNumber"
                    label={
                      <span>
                        {this.context.translate("_SEQUENCE_NUMBER_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_SEQUENCE_NUMBER_"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                  >
                    <Input
                      onChange={(e) =>
                        this.validateNumber(e.target.value, "sequenceNumber")
                      }
                    />
                  </Form.Item>

                  <Form.Item
                    className="formFieldsStyle"
                    name="primaryDriver"
                    label={
                      <span>
                        {this.context.translate("_PRIMARY_DRIVER_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_PRIMARY_DRIVER_"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                  >
                    <Select
                      name="driverId"
                      onChange={async (e) =>
                        await this.setPrimaryIdentityNumber(e)
                      }
                      fieldNames={{ label: "name", value: "driverId" }}
                      optionFilterProp="children"
                      options={this.waslTripStore?.getDrivers}
                      style={{ width: "100%" }}
                    />
                  </Form.Item>

                  <Form.Item
                    className="formFieldsStyle"
                    name="primaryIdentityNumber"
                    label={
                      <span>
                        {this.context.translate("_IDENTITY_NUMBER_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_IDENTITY_NUMBER_"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    className="formFieldsStyle"
                    name="assistantDriver"
                    label={
                      <span>
                        {this.context.translate("_ASSISTANT_DRIVER_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_ASSISTANT_DRIVER_"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                  >
                    <Select
                      name="driverId"
                      onChange={async (e) =>
                        await this.setAssistantIdentityNumber(e)
                      }
                      fieldNames={{ label: "name", value: "driverId" }}
                      optionFilterProp="children"
                      options={this.waslTripStore?.getDrivers}
                      style={{ width: "100%" }}
                    />
                  </Form.Item>

                  <Form.Item
                    className="formFieldsStyle"
                    name="assistantIdentityNumber"
                    label={this.context.translate("_IDENTITY_NUMBER_")}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    className="formFieldsStyle"
                    name="tripNumber"
                    label={this.context.translate("_TRIP_NUMBER_")}
                    initialValue={1}
                  >
                    <Input
                      disabled
                      // onChange={(e) => {
                      //   let value = e.target.value.replace(/\D/g, " ");
                      //   this.setState({ tripNumber: value });
                      // }}
                    />
                  </Form.Item>
                </Col>
                <Col span={12} className="waslFormClass">
                  <Form.Item
                    className="formFieldsStyle"
                    name="departureTime"
                    label={
                      <span>
                        {this.context.translate("_WASL_TRIP_DEPARTURE_TIME")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_WASL_TRIP_DEPARTURE_TIME"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                  >
                    <DatePicker
                      showTime={{ format: "HH:mm:ss" }}
                      format={"YYYY-MM-DD HH:mm:ss"}
                      style={{ width: "100%", height: "40px" }}
                    />
                  </Form.Item>

                  <Form.Item
                    className="formFieldsStyle"
                    name="arrivalTime"
                    label={
                      <span>
                        {this.context.translate("_WASL_TRIP_ARRIVAL_TIME")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_WASL_TRIP_ARRIVAL_TIME"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                  >
                    <DatePicker
                      showTime={{ format: "HH:mm:ss" }}
                      format={dateTimeFormat}
                      style={{ width: "100%", height: "40px" }}
                    />
                  </Form.Item>

                  <Form.Item
                    className="formFieldsStyle"
                    name="distanceInMeters"
                    label={
                      <span>
                        {this.context.translate("_DISTANCE_IN_METERS_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_DISTANCE_IN_METERS_"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    className="formFieldsStyle"
                    name="noOfPassenger"
                    label={
                      <span>
                        {this.context.translate("_NO_OF_PASSENGER_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_NO_OF_PASSENGER_"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                  >
                    <Input
                      maxLength={2}
                      onChange={(e) => {
                        this.validateNumber(e.target.value, "noOfPassenger");
                      }}
                    />
                  </Form.Item>

                  <Form.Item
                    className="formFieldsStyle"
                    name="tripType"
                    label={
                      <span>
                        {this.context.translate("_WASL_TRIP_TYPE_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_WASL_TRIP_TYPE_"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                  >
                    <Select
                      style={{ width: "100%" }}
                      placeholder={this.context.translate("_SELECT_TYPE_")}
                    >
                      <Select.Option value="1">
                        {this.context.translate("_INSIDE_CITY_")}
                      </Select.Option>
                      <Select.Option value="2">
                        {this.context.translate("_BETWN_CITIES_")}
                      </Select.Option>
                    </Select>
                  </Form.Item>

                  <Form.Item
                    className="formFieldsStyle"
                    name="activity"
                    label={
                      <span>
                        {this.context.translate("_ACTIVITY_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_ACTIVITY_"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                  >
                    <Select
                      autoClearSearchValue
                      placeholder={this.context.translate("_SELECT_ACTIVITY_")}
                    >
                      <Select.Option value="EDUCATIONAL_TRANSPORT">
                        {this.context.translate("_EDUCATIONAL_TRANSPORT_")}
                      </Select.Option>
                      <Select.Option value="BUS_RENTAL">
                        {this.context.translate("_BUS_RENTAL_")}
                      </Select.Option>
                      <Select.Option value="SPECIALITY_TRANSPORT">
                        {this.context.translate("_SPECIALITY_TRANSPORT_")}
                      </Select.Option>
                    </Select>
                  </Form.Item>

                  <Form.Item
                    className="formFieldsStyle"
                    name="depStationCode"
                    label={
                      <span>
                        {this.context.translate(
                          "_WASL_TRIP_DEPARTURE_STATION_CODE_"
                        )}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_WASL_TRIP_DEPARTURE_STATION_CODE_"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                  >
                    <Select
                      name="depStationCode"
                      fieldNames={{ label: "stationCode", value: "id" }}
                      placeholder={this.context.translate(
                        "_SELECT_STATION_CODE_"
                      )}
                      optionFilterProp="children"
                      options={this.waslTripStore?.getStationList}
                      style={{ width: "100%" }}
                    />
                  </Form.Item>

                  <Form.Item
                    className="formFieldsStyle"
                    name="arStationCode"
                    label={
                      <span>
                        {this.context.translate(
                          "_WASL_TRIP_ARRIVAL_STATION_CODE_"
                        )}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_WASL_TRIP_ARRIVAL_STATION_CODE_"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                  >
                    <Select
                      name="arStationCode"
                      fieldNames={{ label: "stationCode", value: "id" }}
                      placeholder={this.context.translate(
                        "_SELECT_STATION_CODE_"
                      )}
                      optionFilterProp="children"
                      options={this.waslTripStore?.getStationList}
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <div className="formFooter">
                <Button
                  className="formsCancelButton"
                  onClick={() => {
                    this.setState({ showWASLRegistration: false });
                  }}
                >
                  {this.context.translate(
                    "_FLEET_DASHBORD_ROUTEADD_CANCELBTN_"
                  )}
                </Button>
                <Button htmlType="submit" className="formsSaveButton">
                  {this.context.translate("_REGISTER_")}
                </Button>
              </div>
            </Form>
          </Drawer>

          <Modal
            open={this.state.modalVisible}
            width={300}
            // title="Select Columns"
            title={this.context.translate("_SELECT_COLUMNS_")}
            onCancel={() => this.setState({ modalVisible: false })}
            onOk={() => {
              this.setState({ modalVisible: false });
            }}
            footer={null}
          >
            <div style={{ maxHeight: "400px", overflowY: "auto" }}>
              {this.newColumns.map((column, v) => {
                return (
                  <Row key={v}>
                    <Col>
                      <Checkbox
                        onChange={() => this.handleCheckboxChange(column)}
                        checked={this.state.selectedColumns.some(
                          (c) => c.key === column.key
                        )}
                      >
                        {column.title}
                      </Checkbox>
                    </Col>
                  </Row>
                );
              })}
            </div>
          </Modal>
        </div>
      </>
    );
  }
}
WASLTrip.contextType = StoreContext;
export default observer(withRouter(WASLTrip));
